const Raptor = Mach.requireModule('Raptor');

export enum ShopMonitorValue {
  FAILED = 0,
  SUCCESS = 1,
}

export class ShopMonitor {
  /**
     * 通参
     */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion ?? '',
    bundleName: Mach.env.bundleName ?? '',
  }
  /**
     * 采样率
     */
  sampleRate = 1.0;

  /**
     * 点击banner跳转落地页的监控埋点
     */
  openBannerLandingPageRate = (value: ShopMonitorValue, params = {}) => {
    const tags = { ...params, status: value };
    this.reportMetrics({ OpenShopBannerLandingPageRate: value }, tags);
  }

  /**
     * 上报Report监控指标
     * @param params
     * @param tags
     */
  reportMetrics = (params, tags = {}) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, ...this.defaultTags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, this.sampleRate);
  }
  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }
}

export const shopMonitor = new ShopMonitor();
